import { ToDoDescriptor } from './types';
import { useAssignedTasksToDo } from './hooks/useAssignedTasksToDo';
import { useClientConnectionsToDo } from './hooks/useClientConnectionsToDo';
import { useCompleteQuestionnaireToDo } from './hooks/useCompleteQuestionnaireToDo';
import { useExpiringQuestionsToDo } from './hooks/useExpiringQuestionsToDo';
import { useFlexTrackToDo } from './hooks/useFlexTrackToDo';
import { useIncidentReportsToDo } from './hooks/useIncidentReportsToDo';
import { useInsuranceToDo } from './hooks/useInsuranceToDo';
import { useOperationsReportingToDo } from './hooks/useOperationsReportingToDo';
import { useProfileToDo } from './hooks/useProfileToDo';
import { useProgramReviewsToDo } from './hooks/useProgramReviewsToDo';
import { useReviewClientServicesToDo } from './hooks/useReviewClientServicesToDo';
import { useTrainingComplianceToDo } from './hooks/useTrainingComplianceToDo';
import { useVerificationsToDo } from './hooks/useVerificationsToDo';

// The order below defines the widget's visual order and must mirror the pre-refactor output exactly.
// Each hook owns its own fetch + selectors + visibility rule and returns a fixed set of descriptors so
// that every source keeps contributing its `isFetching` flag even while its items are not visible.
export const useToDoDescriptors = (): ToDoDescriptor[] => [
  ...useProfileToDo(),
  ...useCompleteQuestionnaireToDo(),
  ...useClientConnectionsToDo(),
  ...useReviewClientServicesToDo(),
  ...useProgramReviewsToDo(),
  ...useTrainingComplianceToDo(),
  ...useIncidentReportsToDo(),
  ...useAssignedTasksToDo(),
  ...useVerificationsToDo(),
  ...useInsuranceToDo(),
  ...useExpiringQuestionsToDo(),
  ...useFlexTrackToDo(),
  ...useOperationsReportingToDo()
];
